import React, { Component } from "react";
// import { logout } from "../Utils/authentication";
import { ToastContainer, toast } from "react-toastify";
import { Link } from "react-router-dom";

import "react-toastify/dist/ReactToastify.css";
import { loginUrl } from "../Utils/constant";
import { iamLogout } from "../Utils/dsa";
import { EVENT_TYPES, trackEvent } from "../Utils/analytics";
toast.configure();

export class Header extends Component {
  state = {
    isLoading: false
  };
  onLogOut = () => {
    if (!this.state.isLoading) {
      this.setState({ isLoading: true });
      const userData = JSON.parse(localStorage.getItem("userData") || "{}");
      const { adminEmployeeId: employee_code } = userData;
      const data = {
        employee_code,
        channel: "CENTRAL_ADMIN_UI"
      }
      trackEvent(EVENT_TYPES.LOGOUT, {employee_id: employee_code});
      iamLogout(data);
    }
  };

  render() {
    return (
      <header>
        <div
          className="dash_head justify-content-end logout-btn"
          disabled={this.state.isLoading}
        >
          <a
            className="button"
            onClick={this.onLogOut}
            disabled={this.state.isLoading}
          >
            <i
              className="logout-icon fas fa-power-off"
              disabled={this.state.isLoading}
            ></i>
            <div
              className="logout font-weight-bold"
              disabled={this.state.isLoading}
            >
              {this.state.isLoading ? (
                <i
                  class="fa fa-spinner fa-spin"
                  style={{ fontSize: "24px" }}
                ></i>
              ) : (
                "Logout"
              )}
            </div>
          </a>
        </div>
      </header>
    );
  }
}

export default Header;
